
import ReviewHeader from "./ReviewHeader.vue";
import UiLazyImg from "~/components/UI/UiLazyImg.vue";
import UiReadMoreClamp from "~/components/UI/UiReadMoreClamp.vue";

export default {
  name: "ReviewCard",
  components: {
    UiLazyImg,
    UiReadMoreClamp,
    ReviewHeader,
  },
  props: {
    review: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    imageUrl: {
      type: String,
      required: true,
    },
    imageAlt: {
      type: String,
      default: "",
    },
  },
};
